export const getKey = obj => {
  return Object.keys(obj)[0];
};

export const deepGet = (obj, props, defaultValue = "") => {
  // If we have reached an undefined/null property
  // then stop executing and return the default value.
  // If no default was provided it will be undefined.
  if (obj === undefined || obj === null) {
    return defaultValue;
  }

  // If the path array has no more elements, we've reached
  // the intended property and return its value
  if (props.length === 0) {
    return obj;
  }

  // Prepare our found property and path array for recursion
  const foundSoFar = obj[props[0]];
  const remainingProps = props.slice(1);

  return deepGet(foundSoFar, remainingProps, defaultValue);
};
export const isGuid = value => {
  var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
  var match = regex.exec(value);
  return match != null;
};

export const getValueOrDefault = (obj, key, defaultVal = "") => {
  if (obj === null || typeof obj === "undefined") return defaultVal;

  let returnVal = obj[key];

  if (
    typeof returnVal === "undefined" ||
    returnVal === null ||
    returnVal === ""
  ) {
    return defaultVal;
  }
  return obj[key];
};

export const deepAssign = (initial, value, keys) => {
  if (keys.length === 1) {
    const key = keys[0];
    return { ...initial, [key]: value };
  }

  const getByKeys = (keys, initial) => {
    const currentVal = keys.reduce((current, key) => {
      return current[key];
    }, initial);
    const firstKey = keys.reverse()[0];
    return { [firstKey]: currentVal };
  };

  let index = 0;
  return keys.reduce((current, key) => {
    const currentIndex = keys.length - index - 1;
    const remainingKeys = keys.slice(0, currentIndex);
    const currentKey = keys[currentIndex];

    if (currentIndex - 1 >= 0) {
      const parentKey = keys[currentIndex - 1];
      let parentProp = getByKeys(remainingKeys, initial);
      const currentValue = index === 0 ? value : current[currentKey];
      const props = { ...parentProp[parentKey], [currentKey]: currentValue };
      index++;
      return { [parentKey]: props };
    } else {
      return { ...initial, ...current };
    }
  }, {});
};



// WEBPACK FOOTER //
// ./src/utils/objectHelpers.js